var _rect, _rect2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgGooglePlayQr = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 109,
  height: 108,
  viewBox: "0 0 109 108",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  x: 0.5,
  width: 108,
  height: 108,
  rx: 8,
  fill: "white"
})), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
  x: 10.5,
  y: 10,
  width: 88,
  height: 88,
  fill: "url(#pattern0_29075_15441)"
})), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
  id: "pattern0_29075_15441",
  patternContentUnits: "objectBoundingBox",
  width: 1,
  height: 1
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#image0_29075_15441",
  transform: "scale(0.00182815)"
})), /*#__PURE__*/React.createElement("image", {
  id: "image0_29075_15441",
  width: 547,
  height: 547,
  preserveAspectRatio: "none",
  xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAiMAAAIjAQMAAADr5InyAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAGUExURQAAAP///6XZn90AAAAJcEhZcwAADsMAAA7DAcdvqGQAAAJBSURBVHja7dxBboMwEIXhiVhkmRuUo/Ro6dF6FI6QJQvEtLU9eByMhCpVwfR/KxTwlzSLjOyxK5XcNWbIL73rkk/Zlxcpbwf6LCgoKCjHVzr1GZIyJnAWuYWhqlO+dBlRUFBQUJpWHvFKrlkpY+XDgSEXFBQUFJSzKXO4DJnDjTCbmFBQUFBQ/ofynV714+e5BwoKCgrKIRWXzXnAr1aUUFBQUFCOraxi84Bhqx+wKygoKCgoh1d0O3Wl+iAKCgoKSotKiN20mUFcKAorSvViMaWSg4KCgoLSttLlvoGl7CrEuAfF54qCgoKC0q4SE27aK3GoNRjcUFtR6vJcowgKCgoKSlvKsrtIl9Qridi0w0a6w2QoKCgoKE0qUjQLXIHoE2h3p6KSWFBQUFBQXqLEV8LNeKQr/PCPRQ2woTYlMGX2K0ooKCgoKC0qdkYsxvaG2nObWUoOCgoKCkrrShq3bAayfUG3fCjA1oK63DgYUVBQUFBaV1xP2LV6n3vCLr5bgIKCgoLSpKK1uCnExZTijNiUeg6KgoKiAwpKs0olrrNsEwun2JFhU0apBwUFBQWlAcW6xDFD7irY+QB9XlHKSi45KCgoKCiNKtZZdkNjgbhvd5atzqx3F6GgoKCgvFiRvDdUcznIFWNfDUBBQUFBaVEJlcSdIHMZ0nuMKCgoKChNK+XNoh/gzojF2BahXf0AFBSUvUp/IEVO91mE72VTWcUpz/8rQlJ7WNfTDpQ/UvoDKef7i8737aIIvwz7Fem/AHzwmNV9HFp1AAAAAElFTkSuQmCC"
}))));
const ForwardRef = /*#__PURE__*/forwardRef(SvgGooglePlayQr);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/google-play-qr.72b4483d0eaf0095d8dd803941a7cd63.svg";